<template lang="html">
  <div class="shopify-credentials">
    <Guide
      :content="content"
      contentHeading="Final Step - Save Connection Details"
      :contentVideo="contentVideo"
      :closeLink="closeLink"
      :nextLink="closeLink"
      :previousLink="previousLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'ShopifyCredentials',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'shopify-settings',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    previousLink() {
      return {
        name: 'shopify-app-permissions',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
          <p>You will now be presented with your <strong>Storefront access token</strong>. It's a combination of letters and numbers and is 32 characters long. It looks similar to this:</p>

          <h3>61b20a7c1ef83cf00e213dadb5b6384c</h3>

          <p>Copy and paste this token to the <strong>Shopify token</strong> field after proceeding.</p>

          <hr>

          <p>Enter your unique Shopify URL in the <strong>Shopify URL</strong> field. For example: <em>my-shop.myshopify.com</em>.</p>

         <div class="helper-text">
            <p>You will be able to fill out the relevant information after proceeding this step. You can use your browsers back button if you need to revise this step.</p>
          </div>
        `
    },

    contentVideo() {
      return 'https://page-maker-pro.s3.eu-west-2.amazonaws.com/3+-+AMINATION_03_03_v3.mp4'
    }
  }
}
</script>

<style lang="sass">
  .shopify-guide
</style>
